import { render, staticRenderFns } from "./stockAdder.vue?vue&type=template&id=2af97340"
import script from "./stockAdder.vue?vue&type=script&lang=js"
export * from "./stockAdder.vue?vue&type=script&lang=js"
import style0 from "./stockAdder.vue?vue&type=style&index=0&id=2af97340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports